import React from 'react';
import { useTranslation } from 'react-i18next';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
    const { t } = useTranslation();

    return (
        <div className="privacy-policy-container">
            <h1>{t('privacy_policy_title')}</h1>
            <div className="privacy-content">
                <p>{t('privacy_policy_placeholder')}</p>
                {/* Add more detailed sections for your actual privacy policy here */}
            </div>
        </div>
    );
};

export default PrivacyPolicy;
